import React, { Suspense, useEffect, useState } from 'react';
// localization
import { ConfigProvider, Modal } from 'antd';
import moment from 'moment';
import zhCN from 'antd/lib/locale-provider/zh_CN';
import 'moment/dist/locale/zh-cn';
// store
import { Provider, connect } from 'react-redux';
import withStore from '@/store/withStore';
import store from '@/store';
// router
import { HashRouter, Switch, Route, withRouter, RouteComponentProps } from 'react-router-dom';
// base
import Layout from '@/components/Layout';
import Launcher from '@/components/Launcher';
import routes from './routes';
import Loading from '@/components/Loading';
import ErrorBoundary from '@/components/ErrorBoundray';
import ToBindTip from '@/components/ToBindTip/ToBindTip';

// Launcher
const NoPrivilege = () => <Launcher type="403" />;

moment.locale('zh-cn');

const noPowerRoutes = routes.filter(({ show }) => show);

// 将子页面 url 缩短为父页面 url（若为父页面，则 url 不变），
// 用于在下文 ConnectedRoutes 中，匹配到每个页面对应的 rootPower 中的权限数据
routes.forEach((route) => {
  if (route.show) return;
  const pathArr = route.path.split('/');
  (route as any).powerPath = pathArr.slice(0, 3).join('/'); // ['', 'shop', 'global'] -> '/shop/global'
  (route as any).powerBackupPath = pathArr.slice(0, 2).join('/'); // ['', 'order', 'detail'] -> '/order'
});

const isDev = import.meta.env.DEV;

const ConnectedRoutes = withRouter<RouteComponentProps, any>(
  connect(...withStore('basic'))(({ isFood, rootPower, isOpenAccount }) => {
    if (Object.keys(rootPower).length === 0) {
      return (
        <Switch>
          {noPowerRoutes.map(({ path, component }) => (
            <Route key={path} path={path} component={component} exact />
          ))}
        </Switch>
      );
    }
    return (
      <>
        <Switch>
          {routes.map(({ show, path, component, food, powerPath, powerBackupPath }: any) => {
            // 没有绑卡并且路由不是在绑卡页面
            const showBindTip = !isOpenAccount && path !== '/saas-agent/platform';
            if (showBindTip) {
              return <Route key={path} path={path} component={ToBindTip} exact />;
            }

            if (path === '/') {
              return <Route key={path} path={path} component={component} exact />;
            }
            if (show) {
              return <Route key={path} path={path} component={component} exact />;
            }

            const power: any = rootPower[powerPath] || rootPower[powerBackupPath];

            if (isDev) {
              // 错误检查
              if (power === undefined) {
                // console.log(`'${path}' 未找到对应权限数据！`);
                return null;
              }
              if (power.view === undefined) {
                console.log(`'${path}' 权限数据中没有 'view' 字段！`); // eslint-disable-line
                return null;
              }
            }

            // 有查看权限
            if (power && power.view === true) {
              if (isFood && food !== undefined) {
                return <Route key={path} path={path} component={food} exact />;
              }
              if (component !== undefined) {
                return <Route key={path} path={path} component={component} exact />;
              }
              return null;
            }
            // 无查看权限
            return <Route key={path} path={path} component={NoPrivilege} exact />;
          })}
        </Switch>
      </>
    );
  }),
);

const App = () => {
  return (
    <ErrorBoundary>
      <ConfigProvider locale={zhCN}>
        <Provider store={store}>
          <HashRouter>
            <Layout>
              <Suspense fallback={<Loading />}>
                <ConnectedRoutes />
              </Suspense>
            </Layout>
          </HashRouter>
        </Provider>
      </ConfigProvider>
    </ErrorBoundary>
  );
};

export default App;
